/* eslint semi:0 */
import BaseVm from 'vms/BaseVm'
import { toCamelCase, } from 'utils/string'
import { queryString, } from 'utils/window'
import AnalyticsStore from 'stores/analytics/analyticsStore'


export default class AnalyticsBaseService extends BaseVm {

  constructor(options = {}){
    options.store = options.store || AnalyticsStore.create()
    super(options)
    this.state.reportOnce = {}
    this.facebookShare = this.twitterShare = this.whatsappShare = this.socialShare
  }

  get className(){
    return "AnalyticsBaseService"
  }

  onChange(action){
    const legacyActionHandlerName = toCamelCase(action.type.split(':').pop())
    const actionHandlerName = action.analyticsActionName
    const actionHandler = this[legacyActionHandlerName] || this[actionHandlerName]
    if (actionHandler instanceof Function) {
      actionHandler.bind(this)(action)
    }
  }

  logAnalytics(...args){
    if (queryString.showAnalytics) {
      this.info(`tracking ${ this.className }: `, args)
    }
  }

  routeChanged(action){
    this.pageViewed()
  }

  // NOTICE - to identify an action and determine if it was already reported,
  // it does JSON.stringify(action) and uses that as key
  // if an action has properties that contain objects (and not just primitive values)
  // this may not work properly!
  reportOnce(action, reportMethod){
    const reporter = this.className
    this.state.reportOnce[reporter] = this.state.reportOnce[reporter] || {}
    const actionId = JSON.stringify(action)
    const wasReported = this.state.reportOnce[reporter][actionId]
    if (!wasReported) {
      reportMethod()
      this.state.reportOnce[reporter][actionId] = true
    }
  }

  pageViewed(){}

  socialShare(){}

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/analyticsBaseService.js